/**
 * TextInput.
 * @param {String} id Id use in htmlFor property for label and id in input.
 * @param {String} value Value for input field.
 * @param {String} name Name for input field.
 * @param {Function} onChange Function to handle onChange.
 * @param {String} pattern Pattern for input field.
 * @param {String} type Input type text | select | date.
 * @param {String} label Text will be shown as label.
 * @param {Boolean} required Mark to identify that field is required.
 * @param {Boolean} disabled Value to enable or disable field.
 * @param {Function} onKeyDown Function to handle onKeyDowns.
 * @param {Boolean} disabled Value to enable or disable field.
 * @param {Function} onBlur Function to handle onBlur
 * @returns {ReactElement} returns JSX with the component TextInput.
 */

import { RequiredMark } from '../common';

const TextInput = (props) => {
	const {
		id,
		value = '',
		name,
		onChange,
		pattern,
		type,
		label = '',
		required = false,
		onKeyDown,
		disabled = false,
		readOnly = false,
		onBlur,
		placeholder = '',
		testId
	} = props;

	return (
		<>
			<label className="form-label" htmlFor={id}>
				{label} {required && <RequiredMark />}
			</label>
			<input
				id={id}
				data-testid={testId}
				value={value}
				className={`${props.className ? props.className : 'form-control'} ${
					(disabled || readOnly) && 'notAllowed'
				}`}
				name={name}
				onChange={onChange}
				pattern={pattern}
				required={required}
				type={type}
				onKeyDown={onKeyDown}
				disabled={disabled}
				readOnly={readOnly}
				onBlur={onBlur}
				placeholder={placeholder}
				alt={label}
			/>
		</>
	);
};
export default TextInput;
